import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Config } from '../../../../../../config';
import { CommunicationMessageTypes } from '../../../../../shared/enum-files/general-enums';
import { UserInfoService } from '../../../../../shared/services/security.service';
import { ShareConfigService } from '../../../../../shared/services/shareConfig.service';
import { SharedService } from '../../../../../shared/services/shared.service';
import { FroalaEditorOptions } from '../../../../../shared/services/template-froala-options';
import { VariablePopupService } from '../../../../../shared/services/variable-popup.service';
import { AppointmentsService } from '../../../../appointments.service';

@Component({
  selector: 'app-whatsapp-template',
  templateUrl: './whatsapp-template.component.html',
  styleUrls: ['./whatsapp-template.component.scss']
})
export class WhatsappTemplateComponent implements OnInit, OnDestroy {

  private activeCommunicationTabSubscription: Subscription;
  public whatsAppTemplateForm: FormGroup;
  @Input() notificationType:any;

  // Template Editor Froala
  public froalaEditorOptions = new FroalaEditorOptions();
  public setEditorOptions: object;
  public allowedVariblesFor: string = 'appointment';

  // Object Variables
  public userInfo: any = {};
  public languageNameByCode: any = {};

  // Array Variables
  public clientLanguageList: any = [];
  public availablePlaceholdersList: any = [];

  // String Variables
  public selectedTemplateLangCode: string = '';

  // Boolean Variables
  public isOpenPopup: boolean = false;
  public isFolloUpVariablesPopupEnabled: boolean = false;
  public isWhatsAppTemplateValid: boolean = false;

  // Numeric Variables
  public activeTemplateTab: number = 1;


  public showTemplateForm: boolean = false;
  public whatsappTemplateStructureList: any = [];
  public selectedWhatsAppTemplate: any = {};
  public templateData: any = [];
  public appointmentTemObj: any = {};
  public clientWhatsappTemplates: any = {};
  public whatsAppFollowUpMsg: any  = {};
  public enabledPermissions: any;
  public isFollowupMessageEnable:boolean = false;


  public hsmSelectionCoreUrl: string = "";
  public clientCode: string = "";

  public config: any = {};
  public selectedTemplateData: any = {};

  public isHsmPopupVisible: boolean = false;

  constructor(
    private userInfoService: UserInfoService,
    private shareConfigService: ShareConfigService,
    private variablePopupService: VariablePopupService,
    private translate: TranslateService,
    private appointmentsService: AppointmentsService,
    private sharedService: SharedService
  ) {
    this.config = new Config();
    this.clientCode = this.sharedService.getCookie("clientCode");
    this.userInfo = this.userInfoService.get();
    this.selectedWhatsAppTemplate[this.activeTemplateTab] = {};
    this.enabledPermissions = JSON.parse(JSON.stringify(this.userInfoService.userPermissions));
    // this.isFollowupMessageEnable = (this.enabledPermissions.isJRSalesforceEnabled && this.userInfo.AccountLoginType == 'salesforce' && this.enabledPermissions.isNewVariablePopupEnabled) ? false : true;
    this.isFollowupMessageEnable = this.enabledPermissions.isNewVariablePopupEnabled ? false : true;
  }

  ngOnDestroy() {
    this.getSelectedParams();
    this.shareConfigService.activeCommunicationTab = 0;
    this.shareConfigService.changeActiveCommunicationTab();
    this.activeCommunicationTabSubscription.unsubscribe();
  }

  ngOnInit() { 
    this.setEditorOptions = this.froalaEditorOptions.setEditorOptions(2000);
    this.setEditorOptions['toolbarButtons'] = ['my_dropdown'];
    this.froalaEditorOptions.customPopupBtn();
    if(this.shareConfigService.activeCommunicationTab){
      this.activeTemplateTab = this.shareConfigService.activeCommunicationTab;
    }
    
    if(this.enabledPermissions.isJRSalesforceEnabled && this.userInfo.AccountLoginType == 'salesforce'){
      this.getHSMTemplateDetails();
      this.getDetectChanges();
    }
    else{
      this.setClientLanguageList();
      this.presetWhatsappTemplates();
    }

    this.activeCommunicationTabSubscription = this.shareConfigService.activeCommunicationTabObservable.subscribe((item: number) => {
      if(item){
        this.activeTemplateTab = item;

        if(this.enabledPermissions.isJRSalesforceEnabled && this.userInfo.AccountLoginType == 'salesforce'){
          this.getHSMTemplateDetails();
        }
        else{
          this.presetWhatsappTemplates();
        }
      }
    });

  }

  presetWhatsappTemplates() {
    if (this.shareConfigService.clientWhatsappTemplates && Object.keys(this.shareConfigService.clientWhatsappTemplates).length > 0) {
      let hsmTemplatesList = this.shareConfigService.clientWhatsappTemplates;
      
      if (
        this.shareConfigService.selectedWhatsAppTemplate && 
        this.shareConfigService.selectedWhatsAppTemplate[this.activeTemplateTab] &&
        this.shareConfigService.selectedWhatsAppTemplate[this.activeTemplateTab].templateLanguage
      ) {
        this.selectedWhatsAppTemplate[this.activeTemplateTab] = JSON.parse(JSON.stringify(this.shareConfigService.selectedWhatsAppTemplate[this.activeTemplateTab]));
        this.selectedTemplateLangCode = this.selectedWhatsAppTemplate[this.activeTemplateTab].templateLanguage;
        this.templateData = JSON.parse(JSON.stringify(this.shareConfigService.clientWhatsappTemplates[this.selectedTemplateLangCode]));
      }
      else {
        if (hsmTemplatesList[this.shareConfigService.defualtLanguageCode]) {
          this.selectedTemplateLangCode = this.shareConfigService.defualtLanguageCode;
        }
        else {
          this.selectedTemplateLangCode = Object.keys(hsmTemplatesList)[0];
        }
        this.templateData = JSON.parse(JSON.stringify(this.shareConfigService.clientWhatsappTemplates[this.selectedTemplateLangCode]));
        this.selectedWhatsAppTemplate[this.activeTemplateTab] = JSON.parse(JSON.stringify(this.templateData[0]));
        this.updateWhatsAppPayload();
        this.selectedWhatsAppTemplate[this.activeTemplateTab].followUpMessage = "";
      }
      
      this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswersList = [];
      if (this.selectedWhatsAppTemplate[this.activeTemplateTab] && this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers) {
        this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswersList = typeof this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers === "string" ? this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers.split(",") : this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers;
      }
      setTimeout(() => this.fetchTemplate(), 10);
      
    }
    else {
      this.templateData = [];
      this.showTemplateForm = false;
      this.selectedWhatsAppTemplate[this.activeTemplateTab] = {};
    }
  }

  fetchTemplate() {
    //this.isWhatsAppTemplateValid = false;
    this.showTemplateForm = false;
    this.whatsappTemplateStructureList = [];
    this.availablePlaceholdersList = [];
    
    if (this.selectedWhatsAppTemplate[this.activeTemplateTab] && this.selectedWhatsAppTemplate[this.activeTemplateTab].templateBody) {
      if(this.selectedWhatsAppTemplate[this.activeTemplateTab].templateBody.match(/({{)\d+(}})/g)){
        this.availablePlaceholdersList = this.selectedWhatsAppTemplate[this.activeTemplateTab].templateBody.match(/({{)\d+(}})/g);
      }
    }

    if (this.selectedWhatsAppTemplate[this.activeTemplateTab].params && this.selectedWhatsAppTemplate[this.activeTemplateTab].params.length > 0) {
      this.selectedWhatsAppTemplate[this.activeTemplateTab].params.map((paramobj: any) => {
        this.availablePlaceholdersList.push(`{{${paramobj.paraname}}}`);
      });
    }

    let contentRemaining: string = (this.selectedWhatsAppTemplate[this.activeTemplateTab] && this.selectedWhatsAppTemplate[this.activeTemplateTab].templateBody) ? this.selectedWhatsAppTemplate[this.activeTemplateTab].templateBody : '';
    let temp: any = {};
    let currPlaceHolderCode = '';
    let templateFiledsValue: any = {};
    let contentRemainingList: Array<any> = [];

    this.availablePlaceholdersList.forEach((item: any, index: number) => {
      currPlaceHolderCode = item.replace("{{", "").replace("}}", "").replace(/[^a-zA-Z ]/g, "").replace(/(\s)+/g, "_").toLowerCase();
      templateFiledsValue[currPlaceHolderCode] = "";
      contentRemainingList = contentRemaining.split(item);
      contentRemaining = "";

      contentRemainingList.forEach((subItem: any, subIndex: number) => {
        contentRemaining += subItem;

        if (subIndex < contentRemainingList.length - 1) {
          let fieldPlaceholderKey: string = `Lbl_${currPlaceHolderCode.replace(/(\d*)$/g, "")}`;
          let fieldPlaceholder = (this.translate.instant(fieldPlaceholderKey) !== fieldPlaceholderKey) ? this.translate.instant(fieldPlaceholderKey) : currPlaceHolderCode.replace(/(\-|\_|\.)/g, "");

          contentRemaining += `<input type="text" formControlName="${currPlaceHolderCode}" placeholder="${fieldPlaceholder}" />`;
        }
      });
    });

    this.selectedWhatsAppTemplate[this.activeTemplateTab].templateBodyToDisplay = contentRemaining;

    let inputFieldList = this.selectedWhatsAppTemplate[this.activeTemplateTab].templateBodyToDisplay.match(/<(“[^”]*”|'[^’]*’|[^'”>])*>/g);
    let templateBodyToDisplayList = this.selectedWhatsAppTemplate[this.activeTemplateTab].templateBodyToDisplay.split(/<(“[^”]*”|'[^’]*’|[^'”>])*>/g);

    if (templateBodyToDisplayList && templateBodyToDisplayList.length > 0) {
      templateBodyToDisplayList.map((currItem: any) => {
        if (currItem === "/") {
          temp = {};
          temp.fieldCode = "inputField";
          // temp.fieldValue = inputFieldList[0].match(/(?<=(formControlName="))(\w|\d|\_)+(?=("))/g)[0];
          // temp.fieldPlaceholder = inputFieldList[0].match(/(?<=(placeholder="))(\w|\d|\_|\s)+(?=("))/g)[0];
          temp.fieldValue = this.stringToHTML(inputFieldList[0],"formControlName");
          temp.fieldPlaceholder = this.stringToHTML(inputFieldList[0],"placeholder");
          inputFieldList.splice(0, 1);
        }
        else {
          temp = {};
          temp.fieldCode = "text";
          temp.fieldValue = currItem;
        }
        this.whatsappTemplateStructureList.push(temp);
      });
    }

    if (this.selectedWhatsAppTemplate[this.activeTemplateTab].params && this.selectedWhatsAppTemplate[this.activeTemplateTab].params.length > 0) {
      this.selectedWhatsAppTemplate[this.activeTemplateTab].params.map((currParamObj: any) => {
        if (currParamObj.paraname && currParamObj.value) {
          templateFiledsValue[currParamObj.paraname.toLowerCase()] = currParamObj.value;
        }
      });
    }

    this.createTemplateForm(this.availablePlaceholdersList, templateFiledsValue);
    this.showTemplateForm = true;
  }

  stringToHTML(el:any,attr:string) {
    if(el){
      var parser = new DOMParser();
      var doc = parser.parseFromString(el, 'text/html');
      return doc.body.firstElementChild.getAttribute(attr);
    }
    else{
      return "";
    }
  };

  createTemplateForm(fieldsList: any, filedsValueObj: any) {
    let formObj: any = {};
    let fieldCode: string = "";
    let defaultValue: any;
    let validatorsList: any = [];

    for (let item of fieldsList) {
      fieldCode = item.replace("{{", "").replace("}}", "").toLowerCase();
      // fieldCode = this.selectedWhatsAppTemplate.pramsNameByPosition[item].replace("{{", "").replace("}}", "").toLowerCase();
      defaultValue = null;
      validatorsList = [];

      if (filedsValueObj && filedsValueObj[fieldCode]) {
        defaultValue = filedsValueObj[fieldCode];
      }
      // else if((fieldCode == "jobtitle" || fieldCode === "sourcename") && this.automationService.vacatureInfo && this.automationService.vacatureInfo.title){
      //   defaultValue = this.automationService.vacatureInfo.title;
      // }
      else if (fieldCode == "recruiter") {
        defaultValue = this.userInfo.firstName ? this.userInfo.firstName : null;
      }
      else if (fieldCode == "client") {
        defaultValue = this.userInfo.clientOrganization ? this.userInfo.clientOrganization : null;
      }

      if (
        fieldCode === "firstname" && filedsValueObj && filedsValueObj[fieldCode] && filedsValueObj[fieldCode] === "%fname%" || 
        fieldCode === "phoneno" && filedsValueObj && filedsValueObj[fieldCode] && filedsValueObj[fieldCode] === "%phone%" || 
        fieldCode == "jobtitle" && filedsValueObj && filedsValueObj[fieldCode] && filedsValueObj[fieldCode] === "%sourcename%" ||
        fieldCode == "sourcename" && filedsValueObj && filedsValueObj[fieldCode] && filedsValueObj[fieldCode] === "%sourcename%" ||
        fieldCode == "recruiter" && filedsValueObj && filedsValueObj[fieldCode] && filedsValueObj[fieldCode] === "%rfname%" ||
        fieldCode == "recruiterphone" && filedsValueObj && filedsValueObj[fieldCode] && filedsValueObj[fieldCode] === "%rphone%" 
      ) {
        defaultValue = "";
      }
      if (fieldCode !== "firstname" && fieldCode !== "phoneno" && fieldCode !== "recruiter" && 
          fieldCode !== "recruiterphone" &&  fieldCode !== "jobtitle" && fieldCode !== "sourcename") {
        validatorsList.push(Validators.required);
      }

      formObj[fieldCode.replace("{{", "").replace("}}", "").replace(/[^a-zA-Z ]/g, "").replace(/(\s)+/g, "_")] = new FormControl(defaultValue, validatorsList);
    }
    this.whatsAppTemplateForm = new FormGroup(formObj);
    if (this.whatsAppTemplateForm.status && this.whatsAppTemplateForm.status.toLowerCase() === "valid") {
      this.isWhatsAppTemplateValid = true;
      this.getSelectedParams();
    }
    else {
      this.isWhatsAppTemplateValid = false;
    }

    this.whatsAppTemplateForm.valueChanges.subscribe((result: any) => {
      if (this.whatsAppTemplateForm.status && this.whatsAppTemplateForm.status.toLowerCase() === "valid") {
        this.isWhatsAppTemplateValid = true;
        this.getSelectedParams();
      }
      else {
        this.isWhatsAppTemplateValid = false;
      }
      console.log(this.whatsAppTemplateForm);
    });
  }

  getSelectedParams() {
    if (this.selectedWhatsAppTemplate[this.activeTemplateTab] && this.selectedWhatsAppTemplate[this.activeTemplateTab].params && this.selectedWhatsAppTemplate[this.activeTemplateTab].params.length > 0) {
      let fieldCode = '';
      this.selectedWhatsAppTemplate[this.activeTemplateTab].params.map((param: any) => {
        fieldCode = param.paraname.replace("{{", "").replace("}}", "").replace(/[^a-zA-Z ]/g, "").replace(/(\s)+/g, "_").toLowerCase();

        if (this.whatsAppTemplateForm.value && this.whatsAppTemplateForm.value[fieldCode]) {
          param.value = this.whatsAppTemplateForm.value[fieldCode];
        }
        else if (fieldCode === "firstname") {
          param.value = "%fname%";
        }
        else if (fieldCode === "phoneno") {
          param.value = "%phone%";
        }
        else if (fieldCode === "recruiter") {
          param.value = "%rfname%";
        }
        else if (fieldCode === "recruiterphone") {
          param.value = "%rphone%";
        }
        else if(fieldCode === "jobtitle" || fieldCode === "sourcename"){
          param.value = "%sourcename%";
        }
        else{
          param.value = '';
        }
      });
    }
  }

  onSelectedTemp(temp) {
    var dynamicDivBtn = document.getElementById("dynamicDiv");
    if (dynamicDivBtn) {
      dynamicDivBtn.parentNode.removeChild(dynamicDivBtn);
    }
    let tempTemplate: string = this.selectedWhatsAppTemplate[this.activeTemplateTab].followUpMessage;
    this.selectedWhatsAppTemplate[this.activeTemplateTab] = JSON.parse(JSON.stringify(temp));
    this.selectedWhatsAppTemplate[this.activeTemplateTab].followUpMessage = tempTemplate?tempTemplate:"";
    //this.isWhatsAppTemplateValid = false;
    this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswersList = [];
    if (this.selectedWhatsAppTemplate[this.activeTemplateTab] && this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers) {
      this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswersList = typeof this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers === "string" ? this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers.split(",") : this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers;
    }
    this.fetchTemplate();
    this.updateWhatsAppPayload();
  }

  openVariablePopup() {
    this.isFolloUpVariablesPopupEnabled = true;
    let variablePopupPayload: any = {};
    let msg = this.froalaEditorOptions.editorRefernce.html.get();
    // variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObj(msg);
    variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObjV3(msg);
    variablePopupPayload.allowedVariblesFor = this.allowedVariblesFor;
    variablePopupPayload.isOpenPopup = true;
    variablePopupPayload.communicationType = "followUpMsg";
    this.variablePopupService.variablePopupOpened = 'followUp';
    this.variablePopupService.variablePopupPayload = variablePopupPayload;
    this.variablePopupService.changeInVariablePopupPayload();
  }

  setClientLanguageList() {
    if (this.shareConfigService.clientWhatsappTemplates && Object.keys(this.shareConfigService.clientWhatsappTemplates).length > 0) {
      this.clientLanguageList = Object.keys(this.shareConfigService.clientWhatsappTemplates).length > 0 ? Object.keys(this.shareConfigService.clientWhatsappTemplates) : [];
    }
    if (this.shareConfigService.languageNameByCode && Object.keys(this.shareConfigService.languageNameByCode).length > 0) {
      this.languageNameByCode = JSON.parse(JSON.stringify(this.shareConfigService.languageNameByCode));
    }
    this.selectedTemplateLangCode = this.shareConfigService.defualtLanguageCode;
  }

  getWhatsAppHSMTemplate() {

    if (this.shareConfigService.clientWhatsappTemplates &&
      this.shareConfigService.clientWhatsappTemplates[this.selectedTemplateLangCode] &&
      this.shareConfigService.clientWhatsappTemplates[this.selectedTemplateLangCode].length > 0
    ) {
      this.templateData = JSON.parse(JSON.stringify(this.shareConfigService.clientWhatsappTemplates[this.selectedTemplateLangCode]));
    } else {
      this.templateData = [];
      this.showTemplateForm = false;
      this.selectedWhatsAppTemplate[this.activeTemplateTab] = {};
    }
    if (this.templateData && this.templateData.length > 0) {
      if (this.selectedWhatsAppTemplate[this.activeTemplateTab].id) {
        let tempTemplate: string = this.selectedWhatsAppTemplate[this.activeTemplateTab].followUpMessage;
        this.templateData.map(tempData => {
          if (tempData.id == this.selectedWhatsAppTemplate[this.activeTemplateTab].id) {
            this.selectedWhatsAppTemplate[this.activeTemplateTab] = JSON.parse(JSON.stringify(tempData));
            this.selectedWhatsAppTemplate[this.activeTemplateTab].followUpMessage = tempTemplate;
            //this.isWhatsAppTemplateValid = false;
          }
        });
      }
      if (!(this.selectedWhatsAppTemplate[this.activeTemplateTab] && Object.keys(this.selectedWhatsAppTemplate[this.activeTemplateTab]).length > 0)) {
        this.selectedWhatsAppTemplate[this.activeTemplateTab] = JSON.parse(JSON.stringify(this.templateData[0]));
      }
      //this.shareConfigService.selectedWhatsAppTemplate = JSON.parse(JSON.stringify(this.selectedWhatsAppTemplate));
      this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswersList = [];
      if (this.selectedWhatsAppTemplate[this.activeTemplateTab] && this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers) {
        this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswersList = typeof this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers === "string" ? this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers.split(",") : this.selectedWhatsAppTemplate[this.activeTemplateTab].allowedAnswers;
      }
      setTimeout(() => this.fetchTemplate(), 10);
    }
    this.updateWhatsAppPayload();
  }

  UpdatePopUpStatus() {
    // let textContent = this.variablePopupService.insertFormulaIntoEditor(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptions);
    let textContent = this.variablePopupService.insertFormulaIntoEditorV3(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptions);
    this.selectedWhatsAppTemplate[this.activeTemplateTab].followUpMessage = textContent;
    this.isFolloUpVariablesPopupEnabled = false;
    if(!this.shareConfigService.listOfUsedVariableObj[this.notificationType]){
      this.shareConfigService.listOfUsedVariableObj[this.notificationType] = {};
    }
    this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.WhatsappTemplateMsg] = [];
    if(this.variablePopupService.listOfUsedVariableObj && this.variablePopupService.listOfUsedVariableObj.length > 0){
      this.variablePopupService.listOfUsedVariableObj.map((item:any) => {
        this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.WhatsappTemplateMsg].push(item.formula);
      })
    }
    this.updateWhatsAppPayload();
  }

  followUpMsgChange(data) {
    if(!this.shareConfigService.listOfUsedVariableObj[this.notificationType]){
      this.shareConfigService.listOfUsedVariableObj[this.notificationType] = {};
    }
    this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.WhatsappTemplateMsg] = this.variablePopupService.getListOfUsedVariableFormulasInMsg(data);
    this.isFolloUpVariablesPopupEnabled = false;
    this.updateWhatsAppPayload();
  }

  CancelPopUpStatus(){
    this.isFolloUpVariablesPopupEnabled = false;
  }

  
  updateWhatsAppPayload() {
    if(this.enabledPermissions.isJRSalesforceEnabled && this.userInfo.AccountLoginType == 'salesforce'){
      let selectedTemp: any = {};
      if(this.selectedTemplateData[this.activeTemplateTab] && Object.keys(this.selectedTemplateData[this.activeTemplateTab]).length > 0){
        selectedTemp = this.selectedTemplateData[this.activeTemplateTab];
        selectedTemp['templateLanguage'] = this.selectedTemplateData[this.activeTemplateTab].templateBody[0].langCode;
        selectedTemp['params'] = this.selectedTemplateData[this.activeTemplateTab].params;
        selectedTemp.templateBody[0].tempBody =this.selectedTemplateData[this.activeTemplateTab].templateBody[0].tempBody.replace(/\n/g, "<br />");
      }
      this.shareConfigService.selectedWhatsAppTemplate[this.activeTemplateTab] = JSON.parse(JSON.stringify(selectedTemp));
    }
    else{
      this.shareConfigService.selectedWhatsAppTemplate[this.activeTemplateTab] = JSON.parse(JSON.stringify(this.selectedWhatsAppTemplate[this.activeTemplateTab]));
    }
  }

  
  getHSMTemplateDetails() {
    if (this.shareConfigService.selectedHSMTemplateDetails && this.shareConfigService.selectedHSMTemplateDetails[this.activeTemplateTab] && Object.keys(this.shareConfigService.selectedHSMTemplateDetails[this.activeTemplateTab]).length > 0) {
      this.selectedTemplateData[this.activeTemplateTab] = JSON.parse(JSON.stringify(this.shareConfigService.selectedHSMTemplateDetails[this.activeTemplateTab]));
    }
    else {
      if (!this.shareConfigService.deletedHSMTemplateFor.includes(this.activeTemplateTab)) {
        if(this.shareConfigService.selectedWhatsAppTemplate[this.activeTemplateTab] && this.shareConfigService.selectedWhatsAppTemplate[this.activeTemplateTab].id){
          let tempInfo: any = this.shareConfigService.selectedWhatsAppTemplate[this.activeTemplateTab];
          this.appointmentsService.getHSMTemplateDetails(this.clientCode, 'appointment', tempInfo.templateLanguage, tempInfo.id).subscribe((result: any) => {
            this.selectedTemplateData[this.activeTemplateTab] = {};
            this.shareConfigService.selectedHSMTemplateDetails[this.activeTemplateTab] = {};
            // if (result && Object.keys(result).length > 0) {
            if (result && result.id && result.templateBody) {
              if(result.templateBody && result.templateBody.length > 0){
                result.templateBody.map((subItem:any) => {
                  if(result.headerParams && result.headerParams.length > 0){
                    subItem = this.getUpdateVariables(result.headerParams, subItem, 'header');  
                  }
                  if(result.params && result.params.length > 0){
                    subItem = this.getUpdateVariables(result.params, subItem, 'tempbody');  
                  }
                });
              }
              this.selectedTemplateData[this.activeTemplateTab] = JSON.parse(JSON.stringify(result));
              this.shareConfigService.selectedHSMTemplateDetails[this.activeTemplateTab] = JSON.parse(JSON.stringify(result));
            }
          }) 
        }
      }
      else{
        this.selectedTemplateData[this.activeTemplateTab] = {};
      }
    }
    setTimeout(() => {
      this.updateWhatsAppPayload();
    }, 1000);
  }

  getDetectChanges() {
    let self = this;
    if (window.addEventListener) {
      window.addEventListener("message", onMessage, false);
    }

    function onMessage(event) {
      // Check sender origin to be trusted
      if ( event.origin == self.config.coreUrl) {
        let data = event.data;
        if (data.mcode == 'hsmSelection') {
          if (data.isTemplateSelected) {
            self.selectedTemplateData[self.activeTemplateTab] = JSON.parse(JSON.stringify(data.selectedTemplate));
            self.shareConfigService.selectedHSMTemplateDetails[self.activeTemplateTab] = JSON.parse(JSON.stringify(data.selectedTemplate));
            self.shareConfigService.deletedHSMTemplateFor.splice(self.shareConfigService.deletedHSMTemplateFor.indexOf(self.activeTemplateTab), 1);
            self.updateWhatsAppPayload();
          }
          self.isHsmPopupVisible = false;
        }
      }
      if (window.addEventListener) {
        window.removeEventListener("message", onMessage, false);
      }
    }
  }


  openHsmSelectionpopup() {
    this.getDetectChanges();
    // this.config.coreUrl = 'http://mydev.jobrock.com:4000'
    if (this.selectedTemplateData[this.activeTemplateTab] && this.selectedTemplateData[this.activeTemplateTab].id) {
      this.hsmSelectionCoreUrl = `${this.config.coreUrl}/hsmSelection?clientCode=${this.clientCode}&type=appointment&lang=${this.selectedTemplateData[this.activeTemplateTab].templateBody[0].langCode}&id=${this.selectedTemplateData[this.activeTemplateTab].id}&audienceType=${this.selectedTemplateData[this.activeTemplateTab].audienceType ? this.selectedTemplateData[this.activeTemplateTab].audienceType : ""}`;
    }
    else {
      this.hsmSelectionCoreUrl = `${this.config.coreUrl}/hsmSelection?clientCode=${this.clientCode}&type=appointment`;
    }
    this.isHsmPopupVisible = true;
  }

  deleteHsmTemplate() {
    this.selectedTemplateData[this.activeTemplateTab] = {};
    this.shareConfigService.selectedHSMTemplateDetails[this.activeTemplateTab] = {};
    this.shareConfigService.deletedHSMTemplateFor.push(this.activeTemplateTab);
    this.updateWhatsAppPayload();
  }

  getUpdateVariables(paramsData:any, contentData:any, updatedFor:string){
    if(paramsData && paramsData.length > 0){
      paramsData.map((item:any) => {
          if(item.params && item.params.length > 0){
            item.params.map((subItem:any) => {
              if(subItem.paraname){
                // Header Text
                if(updatedFor =='header' && contentData.headerText && contentData.headerText.indexOf(`{{${subItem.position}}}`) > -1){
                  // contentData.headerText = contentData.headerText.replace(`{{${subItem.position}}}`, subItem.paraname);
                  contentData.headerText = contentData.headerText.replace(`{{${subItem.position}}}`, `<a href="javascript:void(0);">${subItem.paraname}</a>`);
                } 
                // Body Text
                if(updatedFor == 'tempbody' && contentData.tempBody && contentData.tempBody.indexOf(`{{${subItem.position}}}`) > -1){
                  // contentData.tempBody = contentData.tempBody.replace(`{{${subItem.position}}}`, subItem.paraname);
                  contentData.tempBody = contentData.tempBody.replace(`{{${subItem.position}}}`, `<a href="javascript:void(0);">${subItem.paraname}</a>`);
                } 
              }
            })
          }
      })
    }
    return contentData;
  }

}



// WEBPACK FOOTER //
// ./src/app/appointments/appointment-types/add-appointment-type/messages/whatsapp-template/whatsapp-template.component.ts